import { Expose } from "class-transformer";
import { IsString } from "class-validator";

export class FileViewModel {
  @Expose()
  id!: number | string;
  @IsString()
  @Expose()
  name!: string;
}
